module.exports = __webpack_public_path__ + "media/images/popup_back-6e03e6ff3c5d52f3e849b9aeaa4f94fc.png";